import { render, staticRenderFns } from "./RotatingBacklight.vue?vue&type=template&id=e6d65294&scoped=true&"
import script from "./RotatingBacklight.vue?vue&type=script&lang=ts&"
export * from "./RotatingBacklight.vue?vue&type=script&lang=ts&"
import style0 from "./RotatingBacklight.vue?vue&type=style&index=0&id=e6d65294&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6d65294",
  null
  
)

export default component.exports